<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="300px">
                <v-card>
                    <v-card-title>
                        <span class="headline">
                            {{ title }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form
                                ref="form"
                                lazy-validation>
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.userManage.site.table.name')"
                                        v-model="data.name"
                                        :rules="rules.name"
                                        @change="data.name=formSpaces(data.name)"
                                        dense
                                        outlined
                                    ></v-text-field>
                                    <v-select
                                        :items="place"
                                        :label="$vuetify.lang.t('$vuetify.userManage.site.table.provinceName')"
                                        item-text="name"
                                        item-value="code"
                                        v-model="placeCode"
                                        :rules="rules.areaCode"
                                        @change="getCity"
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="shopTypeList"
                                        :label="$vuetify.lang.t('$vuetify.userManage.site.table.shopTypeName')"
                                        item-text="name"
                                        item-value="value"
                                        v-model="data.shopType"
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="city"
                                        :label="$vuetify.lang.t('$vuetify.userManage.site.table.cityName')"
                                        item-text="name"
                                        item-value="code"
                                        v-model="cityCode"
                                        :rules="rules.areaCode"
                                        @change="getArea"
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-select
                                        :items="area"
                                        :label="$vuetify.lang.t('$vuetify.userManage.site.table.areaName')"
                                        item-text="name"
                                        item-value="code"
                                        v-model="data.areacode"
                                        :rules="rules.areaCode"
                                        dense
                                        outlined
                                    ></v-select>
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.userManage.site.table.contact')"
                                        v-model="data.contact"
                                        :rules="rules.contact"
                                        @change="data.contact=formSpaces(data.contact)"
                                        dense
                                        outlined
                                    ></v-text-field>
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.userManage.site.table.username')"
                                        v-model="data.username"
                                        :rules="rules.username"
                                        @change="data.username=formSpaces(data.username)"
                                        dense
                                        outlined
                                    ></v-text-field>
                                    <v-text-field
                                        :label="$vuetify.lang.t('$vuetify.userManage.site.table.address')"
                                        v-model="data.address"
                                        :rules="rules.address"
                                        @change="data.address=formSpaces(data.address)"
                                        dense
                                        outlined
                                    ></v-text-field>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="handleClose">
                            {{$vuetify.lang.t('$vuetify.userManage.close')}}
                        </v-btn>
                        <v-btn color="primary" @click="handleUpdate" :loading="loading">
                            {{$vuetify.lang.t('$vuetify.userManage.update')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import * as api from '../../../api'
import { Notification } from 'element-ui';

export default {

    props: {
        role : Number,
        place: Array
    },

    data () {
        return {

            title: this.$vuetify.lang.t('$vuetify.userManage.site.editBtn'),

            loading: false,

            dialog: false,

            placeCode: null,
            city: [],
            cityCode: null,
            area: [],
            shopTypeList: [
              {name:'直营店',value:'1'},
              {name:'加盟店',value:'2'},
            ],

            data: {
                name: null,
                contact: null,
                areacode: null,
                groupID: null,
                address: null,
                shopType: null,
                username: null,
            },

            rules: {
                name: [
                  value => this.formSpaces(value) !== '' || this.$vuetify.lang.t('$vuetify.userManage.site.rules.name'),
                  value => (value !== null) || this.$vuetify.lang.t('$vuetify.userManage.site.rules.name'),
                  // 添加不能包含数字的验证
                  value => {
                    if (value && /\d/.test(value)) {
                      return '站点名称不能包含阿拉伯数字';
                    }
                    return true;
                  },
                  // 添加必须以"店"结尾的验证
                  value => {
                    if (value && !value.endsWith('店')) {
                      return '站点名称必须以"店"字结尾';
                    }
                    return true;
                  }
                ],
                contact: [
                    value => this.formSpaces(value) !== '' || this.$vuetify.lang.t('$vuetify.userManage.site.rules.contact'),
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.userManage.site.rules.contact')
                ],
                username: [
                  value => this.formSpaces(value) !== '' || this.$vuetify.lang.t('$vuetify.userManage.site.rules.username'),
                  value => (value !== null) || this.$vuetify.lang.t('$vuetify.userManage.site.rules.username')
                ],
                address: [
                  value => this.formSpaces(value) !== '' || this.$vuetify.lang.t('$vuetify.userManage.site.rules.address'),
                  value => (value !== null) || this.$vuetify.lang.t('$vuetify.userManage.site.rules.address')
                ],
                areaCode: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.userManage.site.rules.areaCode')
                ],
                groupID: [
                    value => (value !== null) || this.$vuetify.lang.t('$vuetify.userManage.site.rules.groupID')
                ]
            }

        }
    },

    methods: {
        formSpaces(str){
            if(str !== null && str !== undefined){
                let res = str.replace(/\s*/g,'')
                return res;
            }
        },

        handleOpen (item) {
            this.data = this.newObject(item);
            if (item.shop_type !== undefined && item.shop_type !== null) {
              this.data.shopType = String(item.shop_type);
            }
            this.placeCode = this.data.areacode.substring(0,2);
            this.cityCode = this.data.areacode.substring(0,4);
            this.initArea();
            this.dialog = true;
        },

        handleClose () {
            this.dialog = false;
            this.$refs.form.reset();
        },

        handleUpdate () {
            if (this.$refs.form.validate()) {
                this.loading = true;
                this.$http.post(api.default.rbac.shopEditUrl, this.data).then(resp => {
                    // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                    if (!resp) return;
                    Notification({
                        type: 'success',
                        message: this.$vuetify.lang.t('$vuetify.userManage.success')
                    });
                    this.$emit('handleSearch');
                }).finally(resp => {
                    this.loading = false;
                    this.handleClose();
                })
            }
        },

        newObject (item) {
            var data = JSON.stringify(item);
            return JSON.parse(data)
        },

        initArea () {
            this.$http.post(api.default.system.placeListUrl, {
                areacode: this.placeCode
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.city = resp.data;
            })
            this.$http.post(api.default.system.placeListUrl, {
                areacode: this.cityCode
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.area = resp.data;
            })
        },

        getCity (value) {
            this.$http.post(api.default.system.placeListUrl, {
                areacode: value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.city = resp.data;
                this.cityCode = this.city[0].code;
                this.getArea(this.cityCode);
            })
        },

        getArea (value) {
            this.$http.post(api.default.system.placeListUrl, {
                areacode: value
            }).then(resp => {
                // 此处都是处理正确获取后台数据的情况， 错误的情况都已经在http内部处理
                if (!resp) return;
                this.area = resp.data;
                this.data.areacode = this.area[0].code;
            })
        }

    }
}
</script>

<style scoped>



</style>